import { addDays, dayLabel, fromIsoDay, isoDay } from 'helper/timeLabels';

// The words of a task's dates, in the texts `text` reads (tasks.*).

// « Aujourd’hui », « Demain », « Hier, mar. 20 oct. », or the day itself.
export const dueText = (task, now, text) => {
  if (task.dueOn === isoDay(now)) return text('today');
  if (task.dueOn === isoDay(addDays(now, 1))) return text('tomorrow');
  const label = dayLabel(fromIsoDay(task.dueOn));
  if (task.dueOn === isoDay(addDays(now, -1))) return text('yesterday', { day: label.toLowerCase() });
  return label;
};

// « 9:30 », or nothing for a task of the whole day.
export const timeText = (task) => (task.dueTime ? task.dueTime.slice(0, 5).replace(/^0/, '') : '');

// « Faite mar. 20 oct. »
export const doneText = (task, text) =>
  text('doneOn', { day: dayLabel(new Date(task.doneAt)).toLowerCase() });

export const isLate = (task, now) => !task.doneAt && task.dueOn < isoDay(now);

// The date of a kanban card, as in the Story: « Jeu. 22 oct. · 9:30 » (the day
// itself, even today or tomorrow), or « Terminée mer. 21 oct. » once done.
export const kanbanDateText = (row, text) => {
  if (row.doneAt) return text('kanbanDoneOn', { day: dayLabel(new Date(row.doneAt)).toLowerCase() });
  const day = dayLabel(fromIsoDay(row.dueOn));
  const time = timeText(row);
  return time ? `${day} · ${time}` : day;
};
